module.exports = __webpack_public_path__ + "img/7831359.png";